import { useNavigate } from "react-router-dom";
import { useResetPassword } from "../../actions/authActions";
import { useState } from "react";
import { useForm } from "react-hook-form";
import textWeight from "../../utils/textWeight";

export default () => {
  const navigate = useNavigate();
  const [loadingToapi, setLoadingToapi] = useState(false);
  const { TextWeight } = textWeight();
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      password: "",
      confirmPassword: "",
    },
  });

  const updateProfileMutation = useResetPassword(setLoadingToapi, navigate);

  const onSubmitProfile = (data) => {
    setLoadingToapi(true);
    updateProfileMutation.mutate({
      password: data.password,
    });
  };
  return {
    onSubmitProfile,
    errors,
    getValues,
    setValue,
    handleSubmit,
    register,
    loadingToapi,
    TextWeight,
  };
};
